import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import common from "./locales/en/common.json"
import messages from "./locales/en/messages.json"
import commonDa from "./locales/da/common.json"
import messagesDa from "./locales/da/messages.json"
import commonDe from "./locales/de/common.json"
import messagesDe from "./locales/de/messages.json"
import commonFr from "./locales/fr/common.json"
import messagesFr from "./locales/fr/messages.json"
import commonIt from "./locales/it/common.json"
import messagesIt from "./locales/it/messages.json"
import commonPl from "./locales/pl/common.json"
import messagesPl from "./locales/pl/messages.json"
import commonEs from "./locales/es/common.json"
import messagesEs from "./locales/es/messages.json"
import commonEl from "./locales/el/common.json"
import messagesEl from "./locales/el/messages.json"
import commonPt from "./locales/pt/common.json"
import messagesPt from "./locales/pt/messages.json"
import commonCs from "./locales/cs/common.json"
import messagesCs from "./locales/cs/messages.json"
import commonKo from "./locales/ko/common.json"
import messagesKo from "./locales/ko/messages.json"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common,
        messages,
      },
      da: {
        common: commonDa,
        messages: messagesDa,
      },
      de: {
        common: commonDe,
        messages: messagesDe,
      },
      fr: {
        common: commonFr,
        messages: messagesFr,
      },
      it: {
        common: commonIt,
        messages: messagesIt,
      },
      pl: {
        common: commonPl,
        messages: messagesPl,
      },
      es: {
        common: commonEs,
        messages: messagesEs,
      },
      el: {
        common: commonEl,
        messages: messagesEl,
      },
      pt: {
        common: commonPt,
        messages: messagesPt,
      },
      cs: {
        common: commonCs,
        messages: messagesCs,
      },
      ko: {
        common: commonKo,
        messages: messagesKo,
      },
    },
    supportedLngs: ["en", "da", "fr", "it", "es", "pl", "de", "el", "pt", "cs", "ko"],
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: {
      // React already escapes rendered strings
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  })

export default i18n
